import { render } from "./Elevator.vue?vue&type=template&id=2209cd9a"
import script from "./Elevator.vue?vue&type=script&lang=js"
export * from "./Elevator.vue?vue&type=script&lang=js"

import "./Elevator.vue?vue&type=style&index=0&id=2209cd9a&lang=scss"

import exportComponent from "/Users/user/Desktop/prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__